var React = require('react');

function EllipseBlueLargeInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"152.5","cy":"-2249.5","r":"3111.5","fill":"#0090D4","fillOpacity":"0.8"}));
}

EllipseBlueLargeInline.defaultProps = {"width":"1366","height":"862","viewBox":"0 0 1366 862","fill":"none"};

module.exports = EllipseBlueLargeInline;

EllipseBlueLargeInline.default = EllipseBlueLargeInline;
